// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip___2tCeM","animated":"animated___14AHA","content":"content___TJK5b","arrow":"arrow___Qzx5v","primary":"primary___10b07","darken":"darken___SiFqQ","brand":"brand___2KUmn","wrong":"wrong___1rDKl","negative":"negative___3ipZy","popover":"popover___2FMfi","normal":"normal___2rTDs","small":"small___21Qug"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/Tooltip/index.scss
// module id = 109
// module chunks = 0